<template>
  <div class="sticky-header-wrapper" v-if="visible">
    <div class="Header" :class="classes">
      <div class="left">
        <!-- logo图 -->
        <div class="logo">
          <img
            class="icon-earth"
            :src="require('@/assets/images/logo@3x.png')"
          />

          <h1 class="title">
            {{ $t('Entrega_order__YnnH') /** DiDi Entrega Business */ }}
          </h1>
        </div>
      </div>
      <!-- 用户信息 -->
      <div class="right" v-if="userVisible">
        <!-- avatar -->
        <UserAvatar :is-login="+phone" :avatar="avatar" @click="onLogin" />
        <!-- 未登录展示登录按钮 -->
        <div v-if="!phone" class="login-btn" @click="onLogin">
          {{ $t('Entrega_frontpage__xEbj') }}
        </div>
        <!-- 登录时展示个人中心 -->
        <UserCenter
          v-if="phone"
          :list="userCenterList"
          @action="action"
          @signout="onLogout"
        >
          <span>{{ userName }}</span>
        </UserCenter>
      </div>
    </div>
  </div>
</template>

<script>
import UserAvatar from './user-avatar.vue';
import UserCenter from './user-center.vue';
import { logoutPopupClick } from '@/omega/business/common';
import { createNamespacedHelpers, mapActions, mapState } from 'vuex';
const { mapGetters } = createNamespacedHelpers('account');
import { getLocalStorage } from '@/utils/localStorage';
import passportMonitor from '@/utils/passportMonitor';
import { getLanguageLong } from '@/utils/locale';
import { getCountry } from '@/utils/index';
import Address from '@/utils/address';
import { getLanguageOptionsForCountry } from '@/config/countryConfig/footer';
import { homePageClick } from '@/omega/business/common';
import { getUrlOrigin } from '@/utils/baseUtil';

export default {
  components: {
    UserAvatar,
    UserCenter,
  },
  name: 'Header',
  props: {
    theme: {
      type: String,
      default: 'light',
    },
    visible: {
      type: Boolean,
      default: true,
    },
    userVisible: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters(['phone']),
    ...mapState({
      isH5: ({ common }) => common.isH5,
    }),
    classes() {
      const { theme } = this;
      let classes = [theme ? `Header--${theme}` : ''];
      return classes;
    },
    avatar() {
      return '';
    },
    userName() {
      if (!this.phone) return;
      const reg = /(\d{3})\d{4}(\d{4})/;
      return String(this.phone).replace(reg, '$1****$2');
    },
    isUser() {
      return getLocalStorage('isLogin') || this.phone;
    },
    country() {
      return getCountry();
    },
    languageOptions() {
      return getLanguageOptionsForCountry(this.country);
    },
    languageName() {
      return this.languageOptions.filter((i) => i?.value !== getLanguageLong());
    },
  },
  watch: {
    isUser: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getToken();
        }
      },
    },
    isH5: {
      immediate: true,
      handler(val) {
        const isShowList = val && this.$route.name !== 'AddAccount';
        const arrH5 = [
          {
            tag: 'bill',
            content: this.$t('Entrega_order__zXtO' /** 快速发单 */),
            icon: 'icon-filled_other',
            type: 1,
            name: 'Bill',
          },
          {
            tag: 'order',
            content: this.$t('FoodC_part3_Order_List_uPvS' /** 订单列表 */),
            type: 3,
            icon: 'icon-filled_order',
            name: 'OrderList',
          },
          {
            tag: 'setting',
            content: this.$t('Entrega_order__qLWr' /** 账户管理 */),
            icon: 'icon-filled_setting',
            type: 4,
            name: 'Account',
          },
          {
            tag: 'language',
            content: this.languageName[0]?.label /** 切换语言 */,
            icon: 'icon-pc_outlined_earth',
            type: 5,
          },
        ];
        const arrHelp = [
          {
            tag: 'help',
            content: this.$t('Entrega_order__grnd' /** 帮助中心 */),
            icon: 'icon-outlined_help',
            type: 2,
          },
        ];
        this.userCenterList = isShowList ? [...arrH5, ...arrHelp] : arrHelp;
      },
    },
  },
  data() {
    return {
      personalCenterShow: false,
      userCenterList: [],
    };
  },
  mounted() {},
  methods: {
    ...mapActions('common', ['getToken']),
    onHome() {
      this.$router.push('/');
    },
    onLogin() {
      if (this.phone) return;
      passportMonitor.login();
    },
    dropdownChange(status) {
      this.personalCenterShow = status;
    },
    action(item) {
      if (!item?.type) return;
      const lang = getLanguageLong();
      const country = getCountry();
      const { cityId } = Address.getAddress();
      const token = getLocalStorage('ticket');
      const url = `https://help.didiglobal.com/passenger-index-new.html?source=app_globalck_home_pc&location_country=${country}&lang=${lang}&kfPageSource=sodaEntregaB2C&token=${token}&cityId=${cityId}&soda_type=c`;
      const value = this.languageName[0]?.value;
      const path = `${getUrlOrigin()}/${value}/entrega-business${
        this.$route.fullPath
      }`;
      switch (item?.type) {
        case 2:
          window.open(url);
          break;
        case 5:
          // 切换语言埋点
          homePageClick({ click_type: 4, language_type: value });
          window.location.href = path;
          break;
        default:
          this.$router.push({ name: item.name });
      }
    },
    async onLogout() {
      // 确认是否退出
      const text = this.$t('Entrega_order__PoSj' /** 您确定要退出吗？ */);
      this.$confirm(text, '', {
        confirmButtonText: this.$t('Entrega_order__LzLZ' /** 退出 */),
        cancelButtonText: this.$t('Entrega_order__bWrw' /** 取消 */),
      }).then(
        () => {
          console.log('点击了确认');
          // 退出登录
          logoutPopupClick({ click_type: 1 });
          passportMonitor.logout();
        },
        () => {
          console.log('点击了取消');
          // 取消退出
          logoutPopupClick({ click_type: 2 });
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
